import { ROUTES } from "app/pages/digital-marketing/ad-intelligence/app/social-channels/constants";
import type { SocialChannelsParamKeys } from "app/pages/digital-marketing/ad-intelligence/app/social-channels/routes.types";
import { createNavigator } from "single-spa/react-app/router/utils/BaseNavigator";

export const socialChannelsNavigation = createNavigator<SocialChannelsParamKeys, { promo: string }>({
    promo: ROUTES.ADS.stateName,
});
